import { createContext, useContext, useMemo } from 'react';

import type { PropsWithChildren } from 'react';

export type DataTableContextValue = { compactMode: boolean; textEllipsis: boolean };

export const DataTableContext = createContext<DataTableContextValue | null>(null);

export const DataTableProvider = (props: PropsWithChildren & DataTableContextValue) => {
  const { children, compactMode, textEllipsis } = props;

  const value: DataTableContextValue = useMemo(
    () => ({
      compactMode,
      textEllipsis,
    }),
    [compactMode, textEllipsis],
  );

  return <DataTableContext.Provider value={value}>{children}</DataTableContext.Provider>;
};

export const useDataTableContext = (): DataTableContextValue => {
  const context = useContext(DataTableContext);
  if (!context) {
    throw new Error('useDataTableContext must be used within a DataTableProvider');
  }
  return context;
};

export const useDataTableSafeContext = (): Partial<DataTableContextValue> => {
  const context = useContext(DataTableContext);
  return context ?? {};
};
